"use client";

import { Typography } from "@/components/ui/typography";
import { privacySupportData } from "./constants";
import { memo } from "react";
import { SupportCardsCarousel } from "@/components/screen/global-components/support";

const TermsSupport = ({}: React.ComponentProps<"section">) => {
  const { title, description, cards } = privacySupportData;

  return (
    <section className="section overflow-hidden bg-white lg:bg-background-secondary">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[784] md:mx-auto md:text-center">
          <Typography variant="heading4">
            <h2>{title}</h2>
          </Typography>
          {!!description && (
            <div className="flex justify-center text-gray-600">
              <Typography variant="subHeadingSm" asChild>
                <p>{description}</p>
              </Typography>
            </div>
          )}
        </div>
        <SupportCardsCarousel cards={cards} className="mt-6 lg:mt-12" />
      </div>
    </section>
  );
};

export default memo(TermsSupport);
